import ThemeOptions from './ThemeOptions';
import {GLoginReducer} from './transaction/GLoginReducer';
import {GBDetailsReducer} from './transaction/GBDetailsReducer';
import {CurrentGBDetailsReducer} from './transaction/CurrentGBDetailsReducer';
import {SessionReducer} from './transaction/SessionReducer';


export default {
  ThemeOptions,GLoginReducer,GBDetailsReducer,CurrentGBDetailsReducer,SessionReducer
};
